import { Link, useNavigate , useParams} from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import { mailSending, mailsend, schoolsurl } from '../../../apis/urls';
import Loader from '../../../common-components/loader'
import { $ } from "react-jquery-plugin";
import Checkbox from "../athlet/Checkbox";





const MemberList = () => {

    const { id } = useParams();
    let navigate = useNavigate();

    useEffect(() => {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setLoader(true);
        
        Listing();
            
    }, []);
    
    let role = localStorage.getItem('userrole')
    let username = localStorage.getItem('username');
    
    let schools='';

    if( role === 'SUPERADMIN')
    {
        schools = id;
     
    }else if (role === 'HO_SCHOOL')
    {
         schools = localStorage.getItem('schoolid')
    }
    //console.log('sccccchid',schools)
    const [loader,setLoader] = useState(false);
    const [result,setResult] = useState([]);

    const Listing = () => {
        
        let token = "Bearer "+localStorage.getItem('token');        
        const instance = axios.create({
            baseURL: schoolsurl+'/'+id+"/users/",
            timeout: 1000000,
            headers: {'authorization': token}
          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data);
            setLoader(false)
            console.log(response.data.data)
           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const [isCheck, setIsCheck] = useState([]);
    const DeleteMember = (id) => {
        let r = window.confirm("Are you sure you want to delete this Permission?");
        if(r == true){ 
            let token = "Bearer "+localStorage.getItem('token');
            const instance = axios.create({
                baseURL: schoolsurl+'/'+id+'/users/'+id,
                timeout: 1000000,
                headers: {'authorization': token}
            }); 
            instance.delete('').then((response) =>{
               Listing();
               navigate("/members/"+schools)
            }).catch((error) =>{
                console.log('error',error.message)
            });
        }
    }

    // new code 
    // const [isCheck, setIsCheck] = useState([]);
    // const handleClick = (e) => {
    //     console.log("checked");
    //     const { id, checked } = e.target;
    //     let selectId = parseInt(id)
    //     console.log("selected id is",selectId);
    //     setIsCheck([...isCheck, selectId]);
    //     if (!checked) {
    //       setIsCheck(isCheck.filter((item) => item !== selectId));
    //     }
    //   //   console.log("isCheck", isCheck);
    //   };
    
    //   console.log(isCheck);



    
      
        const handleCheckboxChange = (userid) => {
           
            let token = "Bearer "+localStorage.getItem('token');
            const instance = axios.create({
                baseURL:`${mailSending}/${userid}`,
                timeout: 1000000,
                headers: {'authorization': token}
            }); 
            instance.patch('').then((response) =>{
               Listing();
             
            }).catch((error) =>{
                console.log('error',error.message)
            });
          
            
        };

       
        
        

        

       
        
        let user_role = localStorage.getItem('userrole');
        console.log(user_role);

       

    //   new code end


let sl =1
    return(
        <div>
            <aside class="right-side areas">    
			    <div class="content-area dash-contentss">
                    <div class="page-title-wrpr">
                        <div class="page-title-left-column">
                            <i class="icon-library1"></i>
                            <h2 class="page-title"> Permissions</h2>
                        </div>
                        <div class="page-rightside-action-column">
                        <Link to={"/memberAdd/"+id} data-toggle="tooltip" title="" className="addbtnitem-link text-anchor" data-original-title="Add New School"><i className="icon-add"></i><span>Add New Permissions</span> </Link>
                        </div>
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li class="breadcrumb-item active" aria-current="page"> Permissions</li>
                        </ol>
                    </nav>

                    <div class="faculty-list-wrpr list-wrpr">
                    {result?.map((item, index)=> (
                        <div class="list faculty" key={index}>

                            <div class="row">
                                <div class="col-md-2">
                                    <div class="faculty-user">Sl No.
                                        <span class="desig">{sl++}</span>
                                    </div>     
                                </div>
                                    
                                    

                                <div class="col-md-4">
                                    <div class="faculty-user">Email
                                        <span class="desig">{item.username}</span>
                                    </div>     
                                </div>
                                        
                                <div class="col-md-2">
                                    <div class="faculty-user">Role
                                        {item.role === "HO_SCHOOL"?
                                        <span class="desig">HOS</span>:null
                                        }
                                        {item.role === "ATHLETIC_MANAGER"?
                                        <span class="desig">ATHLETIC DIRECTOR</span>:null
                                        }                                    
                                    </div>     
                                </div>

                            

                               
                              {(user_role === "HO_SCHOOL" || user_role === "SUPERADMIN") && (
                                <div className="col-md-1">
                                  <div className="faculty-user checkbox-btn-options">
                                    
                                      Email  <span>&nbsp;</span>
                                      <input
                                        type="checkbox"
                                        className="checkbox-input"
                                        checked={item.mailsend==="YES"?true:false}
                                        onChange={(e) =>
                                          handleCheckboxChange(item.id)
                                        }
                                      />
                                   
                                  </div>
                                </div>
                              )}

                              
                            
                                
                                        
                                {/* <div class="col-md-3">
                                    <div class="faculty-user">Status
                                        <span class="desig">{item.status}</span>
                                    </div>     
                                </div> */}
                                        
                                <div class="col-md-3">
                                    <div class="list-action-wrpr text-right roundicons-text">
                                    {/* to={"/edit_jobs/"+id+"/"+item.id} */}
                                        <Link to={"/resetpermission/"+id+"/"+item.id}   data-toggle="tooltip" title="Reset Password"><i style={{background:'#77dd77'}}  class="edit icon-lock-open"></i><span>Reset Password</span></Link>
                                        <Link to={"/memberedit/"+id+"/users/"+item.id}  data-toggle="tooltip" title="Edit"><i  class="edit icon-pencil3"></i><span>Update</span></Link>
                                        {item.username === username?
                                        <button data-toggle="tooltip" title="Cannot delete same user" disabled style={{background:"#fff"}}><a><i className="delete icon-close1" disabled style={{opacity:0.65}}></i><span>Delete</span></a></button>:
                                        <button data-toggle="tooltip" title="Delete" onClick={() => { DeleteMember(item.id) }} style={{background:"#fff"}}><a><i className="delete icon-close1"></i><span>Delete</span></a></button>
                                        }
                                    </div>
                                </div>
                            </div>   
                        </div>
                        ))
                    }



                    </div>

                    {
                    !result?
                    (<div className="nodata">
                        <h2>Sorry! No Members Found</h2>
                    </div>):null
    
                    }
                    
                    { 
                        loader?
                        <div>
                            <div className="loader_container"><Loader/></div>
                        </div>
                        :
                        null
                    }
                </div>

            </aside>

        </div>
    )
}
export default MemberList;
